var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterfaceHome3HomeHouseMapRoof(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2559_31855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3862 21.2851H5.38623C5.12101 21.2851 4.86666 21.1797 4.67912 20.9922C4.49159 20.8046 4.38623 20.5503 4.38623 20.2851V11.2851H1.38623L11.7132 1.89708C11.8973 1.72955 12.1373 1.63672 12.3862 1.63672C12.6351 1.63672 12.8751 1.72955 13.0592 1.89708L23.3862 11.2851H20.3862V20.2851C20.3862 20.5503 20.2809 20.8046 20.0933 20.9922C19.9058 21.1797 19.6514 21.2851 19.3862 21.2851ZM6.38623 19.2851H18.3862V9.44208L12.3862 3.98808L6.38623 9.44208V19.2851ZM12.3862 15.2851C11.7232 15.2851 11.0873 15.0217 10.6185 14.5528C10.1496 14.084 9.88623 13.4481 9.88623 12.7851C9.88623 12.122 10.1496 11.4861 10.6185 11.0173C11.0873 10.5485 11.7232 10.2851 12.3862 10.2851C13.0493 10.2851 13.6852 10.5485 14.154 11.0173C14.6228 11.4861 14.8862 12.122 14.8862 12.7851C14.8862 13.4481 14.6228 14.084 14.154 14.5528C13.6852 15.0217 13.0493 15.2851 12.3862 15.2851Z",
    fill: "#1C9FDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2559_31855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.38623 0.285156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceHome3HomeHouseMapRoof);
export default __webpack_public_path__ + "static/media/interface-home-3--home-house-map-roof.7d5c708104c9e45d930e611a04eeff32.svg";
export { ForwardRef as ReactComponent };